import 'antd/lib/style/index.less' // antd core styles
import './styles/vendors/antd/themes/default.less' // default theme antd components
import './styles/vendors/antd/themes/dark.less' // dark theme antd components
import './styles/global.scss' // app & third-party component styles

import React from 'react'
import ReactDOM from 'react-dom'
import { createHashHistory } from 'history'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
// import { logger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'connected-react-router'
import { composeWithDevTools } from 'redux-devtools-extension'
import config from 'devextreme/core/config'

import reducers from './core/store/reducers'
import sagas from './core/store/sagas'
import Localization from './localization'
import Router from './router'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import getConfiguration from './core/services/configuration'

// mocking api
// import 'services/axios/fakeApi'

// middlewared
getConfiguration()
const history = createHashHistory()
const sagaMiddleware = createSagaMiddleware()
const routeMiddleware = routerMiddleware(history)
const middlewares = [sagaMiddleware, routeMiddleware]
// if (process.env.NODE_ENV === 'development') {
//   middlewares.push(logger)
// }

const composeEnhancers = composeWithDevTools({
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
})
const store = createStore(reducers(history), composeEnhancers(applyMiddleware(...middlewares)))
sagaMiddleware.run(sagas)

config({
  rtlEnabled: false,
  forceIsoDateParsing: true,
})

ReactDOM.render(
  <Provider store={store}>
    <Localization>
      <Router history={history} />
    </Localization>
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.unregister();
export { store, history }
